import React from "react";
import "./AddRelocationDetailMobileView.css";
import { useEffect, useState } from "react";
import CallIcon from "@mui/icons-material/Call";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

function AddRelocationDetailMobileView({ preview, activeForm, setActiveForm }) {
  const OpenPetForm = async (e) => {
    
    e.preventDefault();
    
    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateRelocationOrderSummary`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      
    } catch (error) {
      console.error("Error posting data:", error);
    }
    setActiveForm({
      customerDetails: false,
      relocationDetails: false,
      petDetails: true,
      preview: false,
      documentation: false,
    });
  };

  const baseAPI = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const [orderRelocation, setOrderRelocation] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderRelocation(response.data.data[0]);
          setFirstItem(response.data.data[0]);

          
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    origin_country: "",
    First_Name: "",
    Mobile_No: "",
    alternate_number: "",
    Email: "",
    origin_address: "",
    Origin_Pin: "",
    origin_city: "",
    origin_state: "",

    destination_country: "",
    destination_contact_person: "",
    receiver_contact_no: "",
    receiver_alternate_no: "",
    receiver_alternate_email: "",
    destination_address: "",
    Destination_Pin: "",
    destination_city: "",
    destination_state: "",
  });

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  return (
    <div className="">
      <div
        className="relocation-detail-main py-4"
        style={{
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          backgroundColor: "white",
        }}
      >
        <div className="">
          <h1 style={{ fontSize: "20px", margin: "14px" }} className="heading">
            Relocation Details
          </h1>
          <div className="px-3">
            <h4
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "10px 18px 3px 0px",
              }}
              className="mt-4 relocation-heading2"
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  padding: "10px 18px 10px 18px",
                  borderBottom: "3px solid #5B489D",
                  padding: "0px",
                }}
                className="text-start"
              >
                Sender's Details{" "}
              </span>
            </h4>
          </div>

          {preview ? (
            <div
              style={{ paddingBottom: "30px" }}
              className="relocation-details-main-form px-3 m-0"
            >
              <div className="form-row row align-items-start">
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Lead ID
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Relocation_ID}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Full Name
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.First_Name}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Contact Number
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Mobile_No}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Alternative Number
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.alternate_number}
                  </h4>
                </div>
              </div>

              <div className="form-row row align-items-start">
                <div style={{}} className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Email ID
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                      paddingRight: "10px",
                    }}
                  >
                    {orderRelocation.Email}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Address
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                      paddingRight: "20px",
                    }}
                  >
                    {orderRelocation.origin_address}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "29px",
                      paddingLeft: "2px",
                    }}
                  >
                    Pin Code
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Origin_Pin}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    State
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.origin_state1}
                  </h4>
                </div>
              
              </div>

              <div className="form-row row align-items-start">
              <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    City
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.origin_city1}
                  </h4>
                </div>
              </div>
            </div>
          ) : (
            <form className="relocation-details-main-form mt-0">
              <div className="form-row mt-0 row align-items-center">
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Country
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={orderRelocation.origin_country1}
                    disabled
                  />
                </div>
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Full Name
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="First_Name"
                    value={firstItem.First_Name}
                    onChange={handleChange1}
                  />
                </div>
                <div
                  style={{ position: "relative" }}
                  className="col-md-3 col-6"
                >
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Contact Number
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: preview ? "29px" : "27px",
                      paddingTop: preview ? "0px" : "",
                      fontWeight: preview ? "bold" : "",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="Mobile_No"
                    value={firstItem.Mobile_No}
                    onChange={handleChange1}
                  />
                  <CallIcon
                    style={{
                      color: "#6a6a6a",
                      position: "absolute",
                      top: "58px",
                      paddingLeft: preview ? "3px" : "7px",
                    }}
                  />
                </div>
                <div
                  style={{ position: "relative" }}
                  className="col-md-3 col-6"
                >
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Alternate Number
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: preview ? "29px" : "27px",
                      paddingTop: preview ? "0px" : "",
                      fontWeight: preview ? "bold" : "",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="alternate_number"
                    value={firstItem.alternate_number}
                    onChange={handleChange1}
                  />
                  <SmartphoneIcon
                    style={{
                      color: "#6a6a6a",
                      position: "absolute",
                      top: "58px",
                      paddingLeft: preview ? "3px" : "7px",
                    }}
                  />
                </div>
              </div>
              <div className="form-row row align-items-center">
                <div
                  style={{ position: "relative" }}
                  className="col-md-6 col-12"
                >
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Email Address
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: preview ? "29px" : "27px",
                      paddingTop: preview ? "0px" : "",
                      fontWeight: preview ? "bold" : "",
                    }}
                    type="email"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="Email"
                    value={firstItem.Email}
                    onChange={handleChange1}
                  />
                  <SmartphoneIcon
                    style={{
                      color: "#6a6a6a",
                      position: "absolute",
                      top: "58px",
                      fontSize: "18px",
                      paddingLeft: preview ? "3px" : "7px",
                    }}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Address
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="origin_address"
                    value={firstItem.origin_address}
                    onChange={handleChange1}
                  />
                </div>
              </div>
              <div className="form-row row align-items-center px-0">
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    PinCode
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="Origin_Pin"
                    value={firstItem.Origin_Pin}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    State
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    className="form-select m-0"
                    aria-label=""
                    value={orderRelocation.origin_state1}
                    disabled
                  />
                    
                </div>
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    City
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    className="form-select m-0"
                    aria-label="Default select example"
                    value={orderRelocation.origin_city1}
                    disabled
                  />
                </div>
                
              </div>
            </form>
          )}
        </div>

        <div className="">
          <div className="px-3">
            <h4
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "10px 18px 3px 0px",
              }}
              className="mt-4 relocation-heading2"
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  padding: "10px 18px 10px 18px",
                  borderBottom: "3px solid #5B489D",
                  padding: "0px",
                }}
                className="text-start"
              >
                Reciever's Details{" "}
              </span>
            </h4>
          </div>
          {preview ? (
            <div
              style={{ paddingBottom: "30px" }}
              className="relocation-details-main-form px-3 m-0"
            >
              <div className="form-row row align-items-center">
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Lead ID
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Relocation_ID}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Full Name
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.destination_contact_person}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Contact Number
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.receiver_contact_no}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Alternative Number
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.receiver_alternate_no}
                  </h4>
                </div>
              </div>

              <div className="form-row row align-items-center">
                <div style={{}} className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Email ID
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                      paddingRight: "10px",
                    }}
                  >
                    {orderRelocation.receiver_alternate_email}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Address
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                      paddingRight: "20px",
                    }}
                  >
                    {orderRelocation.destination_address}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "29px",
                      paddingLeft: "2px",
                    }}
                  >
                    Pin Code
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Destination_Pin}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    State
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.destination_state1}
                  </h4>
                </div>
               
              </div>

              <div className="form-row row align-items-center">
              <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    City
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.destination_city1}
                  </h4>
                </div>
              </div>
            </div>
          ) : (
            <form className="relocation-details-main-form">
              <div className="form-row row align-items-center px-0">
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Country
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={orderRelocation.destination_country1}
                    disabled
                  />
                </div>
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Full Name
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="destination_contact_person"
                    value={firstItem.destination_contact_person}
                    onChange={handleChange1}
                  />
                </div>
                <div
                  style={{ position: "relative" }}
                  className="col-md-3 col-6"
                >
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Contact Number
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: preview ? "29px" : "27px",
                      paddingTop: preview ? "0px" : "",
                      fontWeight: preview ? "bold" : "",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="receiver_contact_no"
                    value={firstItem.receiver_contact_no}
                    onChange={handleChange1}
                  />
                  <CallIcon
                    style={{
                      color: "#6a6a6a",
                      position: "absolute",
                      top: "58px",
                      paddingLeft: "7px",
                      fontSize: preview ? "18px" : undefined,
                      paddingLeft: preview ? "3px" : "7px",
                    }}
                  />
                </div>
                <div
                  style={{ position: "relative" }}
                  className="col-md-3 col-6"
                >
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Alternate Number
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: preview ? "29px" : "27px",
                      paddingTop: preview ? "0px" : "",
                      fontWeight: preview ? "bold" : "",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="receiver_alternate_no"
                    value={firstItem.receiver_alternate_no}
                    onChange={handleChange1}
                  />
                  <SmartphoneIcon
                    style={{
                      color: "#6a6a6a",
                      position: "absolute",
                      top: "58px",
                      paddingLeft: "7px",
                      fontSize: preview ? "18px" : undefined,
                      paddingLeft: preview ? "3px" : "7px",
                    }}
                  />
                </div>
              </div>
              <div className="form-row row align-items-center">
                <div
                  style={{ position: "relative" }}
                  className="col-md-6 col-12"
                >
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Email Address
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: preview ? "29px" : "27px",
                      paddingTop: preview ? "0px" : "",
                      fontWeight: preview ? "bold" : "",
                    }}
                    type="email"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="receiver_alternate_email"
                    value={firstItem.receiver_alternate_email}
                    onChange={handleChange1}
                  />
                  <SmartphoneIcon
                    style={{
                      color: "#6a6a6a",
                      position: "absolute",
                      top: "58px",
                      paddingLeft: "7px",
                      fontSize: preview ? "18px" : undefined,
                      paddingLeft: preview ? "3px" : "7px",
                    }}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Address
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="destination_address"
                    value={firstItem.destination_address}
                    onChange={handleChange1}
                  />
                </div>
              </div>
              <div className="form-row row align-items-center px-0">
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pin Code
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.Destination_Pin}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    City
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    className="form-select m-0"
                    aria-label="Default select example"
                    value={orderRelocation.destination_city1}
                    disabled
                  />
                </div>
                <div className="col-md-3 col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    State
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    className="form-select m-0"
                    aria-label=""
                    value={orderRelocation.destination_state1}
                    disabled
                  />
                </div>
              </div>
              <hr style={{ marginTop: "46px", marginRight: "20px" }} />
              <div
                style={{ textAlign: "end" }}
                className="form-button-div mt-3 px-3"
              >
                <button
                  onClick={OpenPetForm}
                  style={{
                    paddingBottom: "5px",
                    width: "150px",
                    fontSize: "14px",
                  }}
                  type="submit"
                  className="btn"
                >
                  SAVE & NEXT <span style={{ fontSize: "20px" }}>&rarr;</span>
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddRelocationDetailMobileView;
